import React from 'react'

export default function index() {
  return (
    <div>
      Settings
    </div>
  )
}
